import { defineSlotRecipe } from '@chakra-ui/react';
import { numberInputAnatomy } from '@chakra-ui/react/anatomy';
import { generateInputRecipe } from './inputRecipe';

export function generateNumberRecipe() {
  const inputRecipe = generateInputRecipe();
  return defineSlotRecipe({
    slots: numberInputAnatomy.keys(),
    base: {
      input: {
        ...inputRecipe.base,
        verticalAlign: 'top',
        pe: 'calc(var(--stepper-width) + 0.5rem)'
      }
    },

    variants: {
      size: {
        xs: {
          input: inputRecipe.variants!.size.xs,
          control: {
            fontSize: '2xs',
            '--stepper-width': 'sizes.4'
          }
        },
        sm: {
          input: inputRecipe.variants!.size.sm,
          control: {
            fontSize: 'xs',
            '--stepper-width': 'sizes.5'
          }
        },
        md: {
          input: inputRecipe.variants!.size.md,
          control: {
            fontSize: 'sm',
            '--stepper-width': 'sizes.6'
          }
        },
        lg: {
          input: inputRecipe.variants!.size.lg,
          control: {
            fontSize: 'sm',
            '--stepper-width': 'sizes.6'
          }
        }
      },

      variant: {
        outline: {
          input: inputRecipe.variants!.variant.outline
        },
        subtle: {
          input: inputRecipe.variants!.variant.subtle
        },
        flushed: {
          input: inputRecipe.variants!.variant.flushed
        }
      }
    },
    defaultVariants: {
      size: 'md',
      variant: 'outline'
    }
  });
}
